import { UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router';
import { RouteUrls } from '@lentau/ui-kit/core/enums/route.enum';
import { pageUrlSegment } from './constants';

export function DynamicPromoDetailPageMatcher(segments: UrlSegment[], group: UrlSegmentGroup): UrlMatchResult | null {
  const IdRegExp: RegExp = /\d/;
  const detailUrlSegment: string = 'detail';

  if (group.segments[0] && group.segments[0]?.path !== RouteUrls.Action) {
    return null;
  }
  if (!group.segments[1] || (group.segments[1] && group.segments[1]?.path !== detailUrlSegment)) {
    return null;
  }

  const posParams: { [key: string]: UrlSegment } = {};

  if (IdRegExp.test(segments[2]?.path)) {
    posParams.id = segments[2];
  }

  if (segments[3]?.path === pageUrlSegment && segments[3]) {
    posParams.page = segments[4];
  }

  return {
    consumed: segments,
    posParams,
  };
}
